import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    currentRoute: ''
};
export const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        changeRoute: (state, action) => {
            state.currentRoute = action.payload
        },
    }
});

export const { changeRoute } = layoutSlice.actions;

export const fetchCurrentRoute = (state) => state.layout.currentRoute;

export default layoutSlice.reducer;



